var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ml-auto d-flex",attrs:{"id":"icons"}},[_c('TheHeaderIconBarHelpButton'),_vm._l((_vm.icon_bar),function(x,index){return _c('v-btn',{key:index,attrs:{"icon":""},on:{"click":function($event){return _vm.open_right_navigation_drawer(x)}}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v(" "+_vm._s(x.icon)+" ")])],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }